<template>
    <div class="page-cell">
        <div class="text">{{text}}</div>
        <div class="slot"><slot></slot></div>
        <svg-icon icon-class="arrow" v-if="!hiddenArrow"></svg-icon>
    </div>
</template>

<script>
export default {
    name: "sd-cell",
    props: {
        text: String | Number,
        noIcon: String | Number
    },
    computed: {
        hiddenArrow() {
            return (this.noIcon == '' || this.noIcon)
        }
    }
}
</script>

<style lang="scss" scoped>
.page-cell {
    display: flex;
    height: 64px;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid #E4E8F0;

    .slot {
        flex: 1;
        font-size: 14px;
        color: #787D85;
        text-align: right;
        margin-right: 2px;
    }

    .arrow {
        width: 16px;
        color: #7D7C80;
        transform: rotate(270deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/cell.vue